<template>
	<div id='sre-arc'>
		<h2>功能架构</h2>
		<!-- <div class="box"> -->
		<img src="../assets/images/sre_arc.png" width="55.5%" height="auto" />
		<!-- </div> -->
	</div>
</template>

<script>
	export default {
		name: 'SreArc',
	}
</script>

<style>
	@media(min-width:992px) {
		#sre-arc {
			width: 100%;
			/* height: 965px; */
			background-color: #F1F7FF;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: center;
		}

		#sre-arc h2 {
			margin: 80px 0 40px;
			font-size: 36px;
			font-family: SimHei;
			font-weight: bold;
			color: rgba(51, 51, 51, 1);
		}

		#sre-arc .box {
			display: flex;
			justify-content: center;
			align-content: center;
		}

		#sre-arc img {
			padding: 85px;
			background-color: #E0EDFF;
			border-radius: 4px;
			margin-bottom: 114px;
		}
	}

	@media(max-width:992px) {
		#sre-arc {
			width: 100%;
			background-color: #F1F7FF;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: center;
		}

		#sre-arc h2 {
			margin: 35px 0 0.4rem;
			font-size: 0.2rem;
			font-family: SimHei;
			font-weight: bold;
			color: rgba(51, 51, 51, 1);
		}

		#sre-arc img {
			background-color: #E0EDFF;
			border-radius: 4px;
			margin-bottom: 0.54rem;
		}
	}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/SreArc.vue